"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcRequest = exports.RequestProtocol = void 0;
var RequestProtocol;
(function (RequestProtocol) {
    RequestProtocol["Http"] = "http";
})(RequestProtocol = exports.RequestProtocol || (exports.RequestProtocol = {}));
/**
 * Send Remote Procedure Invocation request throught the underlying network
 */
class RpcRequest {
    constructor(protocol) {
        this.protocol = protocol;
    }
}
exports.RpcRequest = RpcRequest;
//# sourceMappingURL=RpcRequest.js.map